import { Themes } from "../constants"
import { GlobalToken } from "antd"

export const lightTheme = {
	white: "#ffffff",
	offWhite: "rgb(250, 250, 250)",
	black: "#000000",
	dark: "#1f1f1f",
	primary: {
		button: "#ff326d",
		base: "#ff326d",
		headerBorder: "rgb(215, 215, 215)",
		fieldBorder: "#B6C6D7",
		fieldBorderDark: "#6188b0",

		// primary color hue palette
		_0: "#fff0f1",
		_1: "#ffd6dc",
		_2: "#ffadbc",
		_3: "#ff859f",
		_4: "#ff5c85",
		_5: "#ff326d", // base
		_6: "#d9215b",
		_7: "#b3124a",
		_8: "#8c073a",
		_9: "#66042d",
	},
	background: {
		main: "#f2f5f8",
		base: "#f2f4f6",
		_0: "#fcfcfc",
		_1: "#f3f6f6",
		_2: "#f2f2f5",
		_3: "#ebeeee",
		_4: "#dfe2e2",
		_5: "#cbcdd0",
		_6: "#989ba0",
		blue: "#F6F9FC",
		lightGrey: "#F2F2F2",
	},
	text: {
		labelBlue: "#335E90",
		placeholderBlue: "#B6C6D7",

		// monochrome colors
		lighter: "rgb(70,70,70)", // near to #4c4c4c
		light: "rgb(51,51,51)", //  #333333
		body: "rgba(0, 0, 0, 0.85)",
		medium: "#232323",
		bold: "rgb(23, 25, 25)",
		dark: "rgb(10,10,10)",
		darker: "rgb(5,5,5)",
		darkGrey: "rgb(102, 102, 102)", // #666666
		white50: "rgba(255, 255, 255, 0.5)",
		black: "rgba(0, 0, 0, 0.8)",
		descBlack: "rgb(0, 0, 8)",
	},

	//font sizes
	fontSizes: {
		_8: 8,
		_10: 10,
		_12: 12,
		_14: 14,
		_16: 16,
		_20: 20,
		_24: 24,
		_32: 32,
		_48: 48,
		_64: 64,
	},

	//borders
	border: {
		grey: "#D8D8D8",
		darkGrey: "#C4C4C4",
		lightGrey: "rgba(0, 0, 0, 0.2)",
	},

	// states
	success: "#52C41A",
	danger: "#FF4D4F",
	warning: "#FAAD14",
	info: "#1890FF",

	/* special text colours */
	subtitleText: "#9b9b9b",
	selectFieldText: "rgb(145,151,171)",
	selectActiveBackground: "#ffebf1",
	selectFocusedBackground: "#fff6f8",
	selectFocusedText: "rgb(101,106,119)",
	primaryAction: "#e4306e",
	primaryHighlight: "#ff70a0",
	primaryLight: "#ffd9e6",
	primaryShadow: "#400c1d",
	vmanBlue: "#00b4df",
	vmanBlueHover: "#00cdff",
	vmanBlueLight: "rgba(27, 144, 255, 0.15)",
	vmanBlueActive: "rgba(27, 144, 255, 0.6)",
	vmanPink: "#ff326d",
	vmanPinkHoverDarker: "#ff457a",
	vmanPinkHover: "#ff5da2",
	vmanPinkDark: "#f7004a",
	vmanYellow: "#fdc52d",
	amber: "#ffbf00",
}
export const lightToken = {
	colorPrimary: "#7c439c",
	colorPrimaryBorder: "#c4c4c4",
	colorPrimaryHover: "#883ead",
	colorPrimaryTextActive: "#292929",
	colorPrimaryText: "#3D3D3D",
	fontSize: 14,
	borderRadius: 8,
	boxShadow: "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
	colorError: "#b9282a",
	sizeStep: 4,
	sizeUnit: 4,
	colorBgBase: "#ffffff",
	colorTextBase: "#000000",
	colorTextLabel: "#6190c6",
	colorPrimaryBg: "#f9edfd",
} as GlobalToken

export const darkToken = {
	colorPrimary: "#9e96d7",
	colorPrimaryBorder: "#c4c4c4",
	colorPrimaryHover: "#9172bd",
	colorPrimaryTextActive: "#e7e7e7",
	colorPrimaryText: "#272727",
	fontSize: 14,
	borderRadius: 8,
	colorPrimaryActive: "#f6f6f6",
	colorBgBase: "#000000",
	colorError: "#ff4d4f",
	colorTextBase: "#ffffff",
	colorTextLabel: "#6190c6",
} as GlobalToken

export const themeMapper: Record<Themes, GlobalToken> = {
	LIGHT: lightToken,
	DARK: darkToken,
}

export const lightThemedComponent = {
	Button: {
		colorPrimary: lightToken.colorPrimary,
		algorithm: true, // Enable algorithm
	},
	Input: {
		colorPrimary: lightToken.colorPrimary,
		algorithm: true, // Enable algorithm
	},
	Tag: {
		colorPrimary: lightToken.colorPrimary,
		algorithm: true, // Enable algorithm
	},
}

export const darkThemedComponent = {
	Button: {
		colorPrimary: darkToken.colorPrimary,
		algorithm: true, // Enable algorithm
	},
	Input: {
		colorPrimary: darkToken.colorPrimary,
		algorithm: true, // Enable algorithm
	},
	Tag: {
		colorPrimary: darkToken.colorPrimary,
		algorithm: true, // Enable algorithm
	},
}
